'use client';

import { useState } from 'react';

import { Modal } from '../../../Modal/Modal';

import './styles.scss';

import { IMPORT_METHODS } from '@/components/DataIngestion/_constants/data-ingestion';

import FromExport from './components/FromExport/FromExport';
import ImportMethodSelector from './components/ImportMethodSelector';

export const IMPORT_JOURNEY_MODAL_SLUG = 'import-journey-modal';

const ImportJourney = () => {
  const [validImportMethod, setValidImportMethod] = useState<string>('');

  const resetImportState = () => {
    setValidImportMethod('');
  };

  const IMPORT_COMPONENT_BY_METHOD: Record<string, React.ComponentType<unknown>> = {
    [IMPORT_METHODS.FROM_EXPORT]: FromExport,
  };

  const ImportComponent = IMPORT_COMPONENT_BY_METHOD[validImportMethod as keyof typeof IMPORT_COMPONENT_BY_METHOD];
  return (
    <Modal
      slug={IMPORT_JOURNEY_MODAL_SLUG}
      className="fv-import-journey-modal"
      aria-label="Import journey"
      onClose={resetImportState}
      onExited={resetImportState}
    >
      <div className="fv-import-journey-modal__content">
        {!validImportMethod && <ImportMethodSelector setValidImportMethod={setValidImportMethod} />}
        {ImportComponent && <ImportComponent />}
      </div>
    </Modal>
  );
};

export default ImportJourney;
